
import {
  TypeCell,
  TreeAction,
  Permission,
  IHeader,
  ShowCellIn,
} from '../../../../../model/tree-custom/tree.interface';


export enum initialIdRoles {
  AdminGral = 1,
  Alumno = 2,
  Tutor = 3,
  Adtvo = 4
}

export const lockedRoles: number[] = [
  initialIdRoles.AdminGral,
  initialIdRoles.Alumno,
  initialIdRoles.Tutor,
  initialIdRoles.Adtvo
]

export enum initialExtraRolesStudent{
  Graduated = 'egresado',
  ExStudent = 'exalumno',
  Student = 'estudiante',
  restricted = 'restringido'
}

export const lockedRolesNames: string[] = [
  initialExtraRolesStudent.Graduated,
  initialExtraRolesStudent.ExStudent,
  initialExtraRolesStudent.Student,
  initialExtraRolesStudent.restricted
]

export const lockedAdmin: number = initialIdRoles.AdminGral;


export const defaultHeadersRol: IHeader[] = [
  {
    title: 'Add',
    type: TypeCell.PartialCheckbox,
    treeAction: TreeAction.Add,
    hiddenHeader: true,
    showCellIn: ShowCellIn.OnlyRootAndLeaves,
  },
  {
    title: 'Nuevo Modulo',
    type: TypeCell.Title,
    enableMiniCard: true,
    hiddenHeader: true,
    headerActions: { title: 'Categoría', type: TypeCell.Title },
  },
  {
    title: 'Todos',
    type: TypeCell.PropagateCheckbox,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.All,
    headerActions: { title: 'Permisos', type: TypeCell.Title },
  },
  {
    title: 'Aprobar',
    type: TypeCell.Checkbox,
    value: Permission.Aprove,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
  {
    title: 'Crear',
    type: TypeCell.Checkbox,
    value: Permission.Create,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
  {
    title: 'Editar',
    type: TypeCell.Checkbox,
    value: Permission.Edit,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
  {
    title: 'Eliminar',
    type: TypeCell.Checkbox,
    value: Permission.Delete,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
  {
    title: 'Lectura',
    type: TypeCell.Checkbox,
    value: Permission.Read,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
  {
    title: 'Ejecutar',
    type: TypeCell.Checkbox,
    value: Permission.Execute,
    showCellIn: ShowCellIn.Leaves,
    treeAction: TreeAction.Edit,
  },
];
